import { Service, service } from "./di";
import { Flyer } from "../definitions/FlyerDefinitions";
import { StorageService } from "./StorageService";
import * as array from "../utils/array";

export interface CrossBrowseFlyerRunData {
	viewed: number[];
	next: number[];
}

export const VIEWED_LIST_ITEM_FLYER_RUN_IDS = "VIEWED_LIST_ITEM_FLYER_RUN_IDS";

@service("crossBrowseFlyerRunService")
export class CrossBrowseFlyerRunService extends Service {
	init(crossBrowseFlyerRunIds: number[], flyers: Flyer[]): Flyer {
		let flyer;
		const crossBrowseFlyerRunData = {viewed: [], next: []} as CrossBrowseFlyerRunData;
		const flyerIds = flyers.map(flyer => flyer.flyerRunId);
		crossBrowseFlyerRunIds.forEach(id => {
			if (array.contains(flyerIds, id)) {
				if (crossBrowseFlyerRunData.viewed.length === 0) {
					crossBrowseFlyerRunData.viewed.push(id);
				} else {
					crossBrowseFlyerRunData.next.push(id);
				}
			}
		});
		if (crossBrowseFlyerRunData.viewed.length) {
			flyer = flyers.find(flyer => {
				return crossBrowseFlyerRunData.viewed[0] === flyer.flyerRunId;
			});
		}
		StorageService.getInstance().setItem(VIEWED_LIST_ITEM_FLYER_RUN_IDS, JSON.stringify(crossBrowseFlyerRunData));
		return flyer;
	}

	getNextFlyer(flyers: Flyer[]): {flyer: Flyer, crossBrowseListFlyerRunData: CrossBrowseFlyerRunData } {
		let flyer;
		let crossBrowseListFlyerRunData: CrossBrowseFlyerRunData;
		let flyerRunId: number;
		try {
			const list = StorageService.getInstance().getItem(VIEWED_LIST_ITEM_FLYER_RUN_IDS);
			crossBrowseListFlyerRunData = JSON.parse(list) as CrossBrowseFlyerRunData;
			if (crossBrowseListFlyerRunData && crossBrowseListFlyerRunData.next && crossBrowseListFlyerRunData.next.length) {
				const filterFlyer = flyers.filter((flyer) => {
					return flyer.flyerRunId === crossBrowseListFlyerRunData.next[0];
				});
				if (filterFlyer.length) {
					flyer = filterFlyer[0];
					flyerRunId = filterFlyer[0].flyerRunId;
				}
			}
		} catch (e) {
			console.error(e);
		}
		return {flyer, crossBrowseListFlyerRunData};
	}

	handleCrossBrowse = (nextFyerRunId: number): void => {
		const data = this.getData();
		if (!data) return;
		data.next.shift();
		data.viewed.push(nextFyerRunId);
		StorageService.getInstance().setItem(VIEWED_LIST_ITEM_FLYER_RUN_IDS, JSON.stringify(data));
	}

	handleCrossBrowseBack = (): void => {
		const data = this.getData();
		if (!data || (data && data.viewed.length === 1)) return;
		const n = data.viewed.pop();
		data.next.unshift(n);
		StorageService.getInstance().setItem(VIEWED_LIST_ITEM_FLYER_RUN_IDS, JSON.stringify(data));
	}

	private getData(): CrossBrowseFlyerRunData {
		try {
			const list = StorageService.getInstance().getItem(VIEWED_LIST_ITEM_FLYER_RUN_IDS);
			return JSON.parse(list) as CrossBrowseFlyerRunData;
		} catch (e) {
			console.error(e);
			return null;
		}
	}
}
